import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSessao } from '../../auth/contexto'
import { Carregando } from '../../components/Estados'
import { TrocaDeSenhaObrigatoria } from './TrocaDeSenhaObrigatoria'

/**
 * Portão de entrada das telas internas.
 *
 * Guarda o endereço pedido e o devolve depois do login: quem clica num link de GMUD vindo do
 * e-mail do comitê volta para aquela GMUD, e não para a lista. A proteção de verdade é do
 * servidor — nenhuma rota da API é anônima —, esta aqui existe para não mostrar uma tela quebrada
 * a quem não está logado.
 *
 * Guarda a sessão e só. A moldura com menu é o `Layout`, um nível abaixo no roteador, porque nem
 * toda tela protegida a quer: o relatório para impressão sai sem menu nenhum.
 *
 * @returns a tela pedida, ou o desvio para o login
 */
export function RotaProtegida() {
  const { autenticado, carregando, usuario } = useSessao()
  const local = useLocation()

  if (carregando) {
    return <Carregando texto="Verificando seu acesso…" />
  }

  if (!autenticado) {
    const destino = `${local.pathname}${local.search}`
    return <Navigate to="/login" replace state={{ destino }} />
  }

  // A troca obrigatória substitui a aplicação inteira, e não aparece como aviso adiável: a senha
  // foi definida por outra pessoa e chegou por e-mail ou mensagem. Enquanto não for trocada, quem
  // viu a mensagem entra na conta.
  if (usuario?.deveTrocarSenha) {
    return <TrocaDeSenhaObrigatoria />
  }

  return <Outlet />
}
